// eslint-disable-next-line
import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView } from '@/components/layouts'
import { bxAnaalyse } from '@/core/icons'
export const asyncRouterMap = [

  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: '首页' },
    redirect: '/dashboard/workplace',
    children: [
      // dashboard
      {
        path: '/dashboard/workplace',
        name: 'dashboard',
        component: () => import('@/views/dashboard/Workplace'),
        meta: { title: '学习中心', keepAlive: false, icon: bxAnaalyse, permission: ['dashboard'] }
      },

      // syntrain

      {
        path: '/LearnCenter',
        name: 'learncenter',
        component: RouteView,
        meta: { title: '同步训练', icon: 'read', keepAlive: false, permission: ['table'] },
        children: [
          {
            path: '/learncenter/ImproveCourse',
            name: 'ImproveCourse',
            hidden: true,
            component: () => import('@/views/learncenter/impcourse/ImproveCourse'),
            meta: { title: '提高课程', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/readList',
            name: 'read',
            hidden: true,
            component: () => import('@/views/learncenter/read/Read'),
            meta: { title: '智能阅读', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/CourseVideo',
            name: 'CourseVideo',
            hidden: true,
            component: () => import('@/views/learncenter/impcourse/CourseVideo'),
            meta: { title: '课程学习', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/readArticle',
            name: 'readArticle',
            hidden: true,
            component: () => import('@/views/learncenter/read/ReadDetail'),
            meta: { title: '阅读文章', hiddenHeaderContent: false, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/Text_reading',
            name: 'text_reading',
            hidden: true,
            component: () => import('@/views/learncenter/text_reading'),
            meta: { title: '课本朗读', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },

          {
            path: '/notebook/ErrorBook',
            name: 'notebook',
            hidden: true,
            component: () => import('@/views/notebook/ErrorBook'),
            meta: { title: '错题本', keepAlive: false, hiddenHeaderContent: true, permission: ['user'] }
          },
          {
            path: '/learncenter/SpecialTrain',
            name: 'SpecialTrain',
            hidden: true,
            component: () => import('@/views/learncenter/SpecialTrain'),
            meta: { title: '专项训练', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/AIHearsay',
            name: 'AIHearsay',
            hidden: true,
            component: () => import('@/views/learncenter/AIHearsay'),
            meta: { title: '智能听说', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/section',
            name: 'Section',
            hidden: true,
            component: () => import('@/views/learncenter/Section'),
            meta: { title: '课文跟读章节', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/HearSyn',
            name: 'HearSyn',
            component: () => import('@/views/learncenter/HearSyn'),
            meta: { title: '听说同步', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/hearsyn/basicTrain',
            name: 'BasicTrain',
            hidden: true,
            component: () => import('@/views/learncenter/hearsyn/BasicTrain'),
            meta: { title: '听说同步-基础巩固', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }

          },
          {
            path: '/learncenter/hearsyn/auditionIntensify',
            name: 'AuditionIntensify',
            hidden: true,
            component: () => import('@/views/learncenter/hearsyn/AuditionIntensify'),
            meta: { title: '听说同步-听力强化', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/hearsyn/auditionBreach',
            name: 'AuditionBreach',
            hidden: true,
            component: () => import('@/views/learncenter/hearsyn/AuditionBreach'),
            meta: { title: '听说同步-听力突破', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/hearsyn/colligatePromote',
            name: 'ColligatePromote',
            hidden: true,
            component: () => import('@/views/learncenter/hearsyn/ColligatePromote'),
            meta: { title: '听说同步-综合提升', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/hearsyn/seniorPromote',
            name: 'SeniorPromote',
            hidden: true,
            component: () => import('@/views/learncenter/hearsyn/SeniorPromote'),
            meta: { title: '听说同步-综合提升(高中)', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/ReadSyn',
            name: 'ReadSyn',
            component: () => import('@/views/learncenter/ReadSyn'),
            meta: { title: '读写同步', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/readsyn/ReadSection',
            name: 'ReadSection',
            hidden: true,
            component: () => import('@/views/learncenter/readsyn/ReadSection'),
            meta: { title: '读写同步-题型', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/readsyn/UnitWord',
            name: 'UnitWord',
            hidden: true,
            component: () => import('@/views/learncenter/readsyn/UnitWord'),
            meta: { title: '读写同步-单元词汇', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/readsyn/TopicKnow',
            name: 'TopicKnow',
            hidden: true,
            component: () => import('@/views/learncenter/readsyn/TopicKnow'),
            meta: { title: '读写同步-话题知识', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/readsyn/GrammarKnow',
            name: 'GrammarKnow',
            hidden: true,
            component: () => import('@/views/learncenter/readsyn/GrammarKnow'),
            meta: { title: '读写同步-语法知识', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/readsyn/SingleChoice',
            name: 'SingleChoice',
            hidden: true,
            component: () => import('@/views/learncenter/readsyn/SingleChoice'),
            meta: { title: '读写同步-单项选择', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/readsyn/ClozeTest',
            name: 'ClozeTest',
            hidden: true,
            component: () => import('@/views/learncenter/readsyn/ClozeTest'),
            meta: { title: '读写同步-完形填空', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/readsyn/ReadCatch',
            name: 'ReadCatch',
            hidden: true,
            component: () => import('@/views/learncenter/readsyn/ReadCatch'),
            meta: { title: '读写同步-阅读理解', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/readsyn/EssayFill',
            name: 'EssayFill',
            hidden: true,
            component: () => import('@/views/learncenter/readsyn/EssayFill'),
            meta: { title: '读写同步-短文填空', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/readsyn/WriteExpress',
            name: 'WriteExpress',
            hidden: true,
            component: () => import('@/views/learncenter/readsyn/WriteExpress'),
            meta: { title: '读写同步-书面表达', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/readsyn/WordAnalysis',
            name: 'WordAnalysis',
            hidden: true,
            component: () => import('@/views/learncenter/readsyn/WordAnalysis'),
            meta: { title: '读写同步-单元词汇报告页', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/readsyn/TopicAnalysis',
            name: 'TopicAnalysis',
            hidden: true,
            component: () => import('@/views/learncenter/readsyn/TopicAnalysis'),
            meta: { title: '读写同步-话题知识报告页', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/readsyn/GrammarAnalysis',
            name: 'GrammarAnalysis',
            hidden: true,
            component: () => import('@/views/learncenter/readsyn/GrammarAnalysis'),
            meta: { title: '读写同步-语法知识报告页', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/readsyn/SingleAnalysis',
            name: 'SingleAnalysis',
            hidden: true,
            component: () => import('@/views/learncenter/readsyn/SingleAnalysis'),
            meta: { title: '读写同步-单项选择报告页', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/readsyn/ClozeAnalysis',
            name: 'ClozeAnalysis',
            hidden: true,
            component: () => import('@/views/learncenter/readsyn/ClozeAnalysis'),
            meta: { title: '读写同步-完形填空报告页', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/readsyn/ReadAnalysis',
            name: 'ReadAnalysis',
            hidden: true,
            component: () => import('@/views/learncenter/readsyn/ReadAnalysis'),
            meta: { title: '读写同步-阅读理解报告页', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/readsyn/EssayAnalysis',
            name: 'EssayAnalysis',
            hidden: true,
            component: () => import('@/views/learncenter/readsyn/EssayAnalysis'),
            meta: { title: '读写同步-短文填空报告页', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          // {
          //   path: '/learncenter/ReadSection',
          //   name: 'readsection',
          //   hidden: true,
          //   component: () => import('@/views/learncenter/readsection'),
          //   meta: { title: '课本朗读-列表', hiddenHeaderContent: true, keepAlive: true, permission: ['table'] }
          // },
          // {
          //   path: '/learncenter/SectionNext',
          //   name: 'section_next',
          //   hidden: true,
          //   component: () => import('@/views/learncenter/section_next'),
          //   meta: { title: '课本朗读-内容', hiddenHeaderContent: true, keepAlive: true, permission: ['table'] }
          // },

          {
            path: '/learncenter/BookList',
            name: 'booklist',
            hidden: true,
            component: () => import('@/views/learncenter/booklist'),
            meta: { title: '教材选择', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/learncenter/BookUnit',
            name: 'bookUnit',
            hidden: true,
            component: () => import('@/views/learncenter/bookUnit'),
            meta: { title: '单元选择', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/phoneticSymbol',
            name: 'phoneticSymbol',
            hidden: true,
            component: () => import('@/views/composition/PhoneticSymbol'),
            meta: { title: '音标学习', hiddenHeaderContent: true, keepAlive: false }
          },
          // {
          //   path: '/challenge',
          //   name: 'challenge',
          //   hidden: true,
          //   component: () => import('@/views/composition/Challenge'),
          //   meta: { title: '音标学习-挑战一下', hidden: true, hiddenHeaderContent: true, keepAlive: false }
          // },
          // {
          //   path: '/challengeList',
          //   name: 'challengeList',
          //   hidden: true,
          //   component: () => import('@/views/composition/ChallengeList'),
          //   meta: { title: '音标学习-挑战列表', hidden: true, hiddenHeaderContent: true, keepAlive: false }
          // },
          {
            path: '/phoneticDetail',
            name: 'phoneticSymbolDetail',
            hidden: true,
            component: () => import('@/views/composition/PhoneticSymbolDetails'),
            meta: { title: '音标学习-详情', hidden: true, hiddenHeaderContent: true, keepAlive: false }
          },
          {
            path: '/taskDetail',
            name: 'taskDetail',
            hidden: true,
            component: () => import('@/views/task/TaskDetails'),
            meta: { title: '我的作业-详情', hidden: true, keepAlive: false, hiddenHeaderContent: true }
          },
          // {
          //   path: '/taskResultHear',
          //   name: 'taskResultHear',
          //   hidden: true,
          //   component: () => import('@/views/task/TaskAnalysisHear/TaskHearDetails'),
          //   meta: { title: '我的作业-详情', hidden: true, keepAlive: false, hiddenHeaderContent: true }
          // },
          {
            path: '/taskDetailRW',
            name: 'taskDetailRW',
            hidden: true,
            component: () => import('@/views/task/TaskDetailRW'),
            meta: { title: '作业——读写模拟', hidden: true, keepAlive: false, hiddenHeaderContent: true }
          },
          {
            path: '/taskDetailHear',
            name: 'taskDetailHear',
            hidden: true,
            component: () => import('@/views/task/TaskDetailHear'),
            meta: { title: '作业——听说模拟', hidden: true, keepAlive: false, hiddenHeaderContent: true }
          },
          {
            path: '/taskDetailPractice',
            name: 'taskDetailPractice',
            hidden: true,
            component: () => import('@/views/task/TaskDetailPractice'),
            meta: { title: '作业——实践模拟', hidden: true, keepAlive: false, hiddenHeaderContent: true }
          },
          {
            path: '/taskAnalysisRW',
            name: 'taskAnalysisRW',
            hidden: true,
            component: () => import('@/views/task/TaskAnalysisRW/TaskRWAnalysis'),
            meta: { title: '读写模拟解析-详情', hidden: true, keepAlive: false, hiddenHeaderContent: true }
          },
          {
            path: '/taskAnalysisHear',
            name: 'taskAnalysisHear',
            hidden: true,
            component: () => import('@/views/task/TaskAnalysisHear/TaskHearAnalysis'),
            meta: { title: '听说模拟解析-详情', hidden: true, keepAlive: false, hiddenHeaderContent: true }
          },
          {
            path: '/taskAnalysisPractice',
            name: 'taskAnalysisPractice',
            hidden: true,
            component: () => import('@/views/task/TaskAnalysisPractice/TaskPracticeAnalysis'),
            meta: { title: '实践模拟解析-详情', hidden: true, keepAlive: false, hiddenHeaderContent: true }
          },
          {
            path: '/taskDetailsWord',
            name: 'taskDetailsWord',
            hidden: true,
            component: () => import('@/views/task/TaskDetailsWord'),
            meta: { title: '词语速记-详情', hidden: true, keepAlive: false, hiddenHeaderContent: true }
          },
          {
            path: '/taskDetailsSpeak',
            name: 'taskDetailsSpeak',
            hidden: true,
            component: () => import('@/views/task/TaskDetailsSpeak'),
            meta: { title: '智能听说-详情', hidden: true, keepAlive: false, hiddenHeaderContent: true }
          },
          {
            path: '/taskDetailSymbol',
            name: 'taskDetailSymbol',
            hidden: true,
            component: () => import('@/views/task/TaskDetailSymbol'),
            meta: { title: '音标学习-详情', hidden: true, keepAlive: false, hiddenHeaderContent: true }
          }
        ]
      },

      // exam
      {
        path: '/Exam',
        name: 'exam',
        component: RouteView,
        meta: { title: '考试中心', icon: 'edit', permission: ['table'] },
        children: [
          {
            path: '/exam/hear-list',
            name: 'HearExam',
            component: () => import('@/views/exam/HearExam'),
            meta: { title: '听说模拟', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/exam/readAndWrite-list',
            name: 'ReadAndWriteExam',
            component: () => import('@/views/exam/ReadAndWriteExam'),
            meta: { title: '读写模拟', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          },
          {
            path: '/exam/practice-list',
            name: 'PracticeExam',
            component: () => import('@/views/exam/PracticeExam'),
            meta: { title: '听说拓展', hiddenHeaderContent: true, keepAlive: false, permission: ['table'] }
          }
        ]
      },

      // learnanalysis
      {
        path: '/analysis/learnanalysis',
        name: 'LearnAnalysis',
        component: () => import('@/views/analysis/LearnAnalysis'),
        meta: { title: '学情分析', hidden: true, icon: 'bar-chart', keepAlive: false, hiddenHeaderContent: true, permission: ['user'] }
      },
      {
        path: '/Intelligent',
        name: 'Intelligent',
        hidden: true,
        component: () => import('@/views/account/Intelligent'),
        meta: { title: '智能听说', hidden: true, icon: 'bar-chart', keepAlive: false, hiddenHeaderContent: true, permission: ['user'] }
      },
      // task
      {
        path: '/task',
        name: 'task',
        component: () => import('@/views/task/TaskList'),
        meta: { title: '我的作业', hidden: true, icon: 'profile', keepAlive: false, hiddenHeaderContent: true, permission: ['user'] }
      },

      // {
      //   path: '/cloudCard',
      //   name: 'cloudCard',
      //   component: () => import('@/views/account/settings/CloudCard'),
      //   meta: { title: '云卡商城', hidden: true, icon: 'shopping-cart', keepAlive: false, hiddenHeaderContent: true, permission: ['user'] }

      // },
      // {
      //   path: '/Record',
      //   name: 'Record',
      //   component: () => import('@/views/test/Record'),
      //   meta: { title: '测试', hidden: true, icon: 'shopping-cart', keepAlive: true, hiddenHeaderContent: true, permission: ['user'] }

      // },
      {
        path: '/OrderBuy',
        name: 'OrderBuy',
        hidden: true,
        component: () => import('@/views/account/OrderBuy'),
        meta: { title: '云卡购买', hidden: true, icon: 'shopping-cart', keepAlive: false, hiddenHeaderContent: true, permission: ['user'] }
      },
      {
        path: '/WeChatPay',
        name: 'WeChatPay',
        hidden: true,
        component: () => import('@/views/account/WeChatPay'),
        meta: { title: '微信支付', hidden: true, icon: 'shopping-cart', keepAlive: false, hiddenHeaderContent: true, permission: ['user'] }
      },
      // account
      {
        path: '/account',
        component: RouteView,
        name: 'account',
        hidden: true,
        meta: { title: '个人页', icon: 'user', keepAlive: false, permission: ['user'] },
        children: [
          {
            path: '/account/settings',
            name: 'settings',
            component: () => import('@/views/account/settings/Index'),
            meta: { title: '个人设置', hideHeader: true, keepAlive: false, permission: ['user'] },
            redirect: '/account/settings/base',
            alwaysShow: true,
            children: [
              {
                path: '/account/settings/base',
                name: 'BaseSettings',
                component: () => import('@/views/account/settings/BaseSetting'),
                meta: { title: '基本设置', hidden: true, keepAlive: false, permission: ['user'] }
              },
              {
                path: '/account/settings/security',
                name: 'SecuritySettings',
                component: () => import('@/views/account/settings/Security'),
                meta: { title: '安全设置', hidden: true, keepAlive: false, permission: ['user'] }
              },
              {
                path: '/account/settings/binding',
                name: 'BindingSettings',
                component: () => import('@/views/account/settings/Binding'),
                meta: { title: '账户绑定', hidden: true, keepAlive: false, permission: ['user'] }
              }
            ]
          },
          {
            path: '/account/center',
            name: 'center',
            component: () => import('@/views/account/center/Index'),
            meta: { title: '个人中心', keepAlive: false, permission: ['user'] },
            redirect: '/account/myCloudCard',
            alwaysShow: true,
            children: [
              {
                path: '/account/myCloudCard',
                name: 'myCloudCard',
                component: () => import('@/views/account/MyCloudCard'),
                meta: { title: '我的云卡', keepAlive: false }
              },
              {
                path: '/mana/classDynamics',
                name: 'classDynamics',
                component: () => import('@/views/list/ClassDynamics'),
                meta: { title: '班级动态', keepAlive: false }
              },
              {
                path: '/account/Ranking',
                name: 'ranking',
                component: () => import('@/views/account/ranking'),
                meta: { title: '班级排名', keepAlive: false }
              },
              {
                path: '/account/settings/notification',
                name: 'Notification',
                component: () => import('@/views/account/settings/Notification'),
                meta: { title: '消息通知', keepAlive: false }
              },
              {
                path: '/account/settings/notificationDetail',
                name: 'notificationDetail',
                hidden: true,
                component: () => import('@/views/account/settings/NotificationDetail'),
                meta: { title: '消息详情', keepAlive: false }
              },
              {
                path: '/account/feedback',
                name: 'feedback',
                component: () => import('@/views/account/feedback/Feedback'),
                meta: { title: '问题反馈', keepAlive: false }
              },
              {
                path: '/OrderManagement',
                name: 'OrderManagement',
                component: () => import('@/views/account/OrderManagement'),
                meta: { title: '云卡订单', keepAlive: false }
              }
            ]
          }

        ]
      }
    ]
  },
  {
    path: '*', redirect: '/404', hidden: true
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Register')
      },
      {
        path: 'register-result',
        name: 'registerResult',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/RegisterResult')
      }
    ]
  },

  {
    path: '/test',
    component: BlankLayout,
    redirect: '/test/home',
    children: [
      {
        path: 'home',
        name: 'TestHome',
        component: () => import('@/views/Home')
      }
    ]
  },

  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  }

]
